import { Grid, Typography } from "@material-ui/core";

import styled, { css } from "styled-components";

export const GridStyled = styled(Grid)`
  ${(props) =>
    props.$minHeight &&
    css`
      min-height: ${(props) => props.$minHeight} !important;
    `};

  ${(props) =>
    props.$minWidth &&
    css`
      min-width: ${(props) => props.$minWidth} !important;
    `};

  ${(props) =>
    props.$whiteSpace &&
    css`
      white-space: ${(props) => props.$whiteSpace};
    `};

  ${(props) =>
    props.$overflow &&
    css`
      overflow: ${(props) => props.$overflow};
    `};

  ${(props) =>
    props.$height &&
    css`
      height: ${(props) => props.$height};
    `};

  ${(props) =>
    props.$borderRadius &&
    css`
      border-radius: ${(props) => props.$borderRadius};
    `};

  ${(props) =>
    props.$padding &&
    css`
      padding: ${(props) => props.$padding} !important;
    `};

  ${(props) =>
    props.$margin &&
    css`
      margin: ${(props) => props.$margin} !important;
    `};

  ${(props) =>
    props.$marginBottom &&
    css`
      margin-bottom: ${(props) => props.$marginBottom} !important;
    `};

  ${(props) =>
    props.$marginTop &&
    css`
      margin-top: ${(props) => props.$marginTop} !important;
    `};

  ${(props) =>
    props.$lineHeight &&
    css`
      line-height: ${(props) => props.$lineHeight};
    `};

  ${(props) =>
    props.$boxShadow &&
    css`
      box-shadow: ${(props) => props.$boxShadow};
    `};

  ${(props) =>
    props.$border &&
    css`
      border: ${(props) => props.$border};
    `};

  ${(props) =>
    props.$borderColor &&
    css`
      border-color: ${(props) => props.theme.palette[props.$borderColor]};
    `};

  ${(props) =>
    props.$boxShadow &&
    css`
      box-shadow: ${(props) => props.$boxShadow};
    `};

  ${(props) =>
    props.$cursor &&
    css`
      cursor: ${(props) => props.$cursor};
    `};

  background-color: ${(props) =>
    props.theme.palette[props.$backgroundColor || "transparent"]};

  ${(props) =>
    props.$backgroundColorHover &&
    css`
      :hover {
        background-color: ${(props) => props.$backgroundColorHover};
      }
    `};

  ${(props) =>
    props.$position &&
    css`
      position: ${(props) => props.$position};
    `};

  ${(props) =>
    props.$top &&
    css`
      top: ${(props) => props.$top};
    `};
`;

export const LabelStyled = styled.label`
  ${(props) =>
    props.$fontSize &&
    css`
      font-size: ${(props) => props.$fontSize};
    `};

  ${(props) =>
    props.$fontFamily &&
    css`
      font-family: ${(props) => props.$fontFamily};
    `};

  ${(props) =>
    props.$margin &&
    css`
      margin: ${(props) => props.$margin} !important;
    `};

  ${(props) =>
    props.$color &&
    css`
      color: ${(props) => props.theme.palette[props.$color]};
    `};

  ${(props) =>
    props.$fontWeight &&
    css`
      font-weight: ${(props) => props.$fontWeight};
    `};

  ${(props) =>
    props.$cursor &&
    css`
      cursor: ${(props) => props.$cursor};
    `};

  ${(props) =>
    props.$textAlign &&
    css`
      text-align: ${(props) => props.$textAlign};
    `};
`;

export const TypographyStyled = styled(Typography)`
  ${(props) =>
    props.$fontWeight &&
    css`
      font-weight: ${(props) => props.$fontWeight} !important;
    `};

  ${(props) =>
    props.$fontSize &&
    css`
      font-size: ${(props) => props.$fontSize} !important;
    `};

  ${(props) =>
    props.$fontFamily &&
    css`
      font-family: ${(props) => props.theme.fonts.$fontFamily} !important;
    `};

  ${(props) =>
    props.$color &&
    css`
      color: ${(props) => props.theme.palette[props.$color]};
    `};
`;
